import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=d0ed6574&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=d0ed6574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ed6574",
  null
  
)

/* custom blocks */
import block0 from "./Header.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiLanguages: require('/var/www/html/intelli.com.br/components/base/ui/Languages.vue').default,BaseUiSocialMedias: require('/var/www/html/intelli.com.br/components/base/ui/SocialMedias.vue').default,BaseUiSearch: require('/var/www/html/intelli.com.br/components/base/ui/Search.vue').default,BaseUiSearchModalContent: require('/var/www/html/intelli.com.br/components/base/ui/SearchModalContent.vue').default})
